import { apiClient } from './apiClient';

// Synchronous accessor used by AppTabs, ChatPage, PostDetailPage in the places
// that previously read `fireAuth.getAuth().currentUser.uid`. The backend sets a
// non-httpOnly `uid` cookie alongside the auth cookies for exactly this
// purpose — it's a copy of the JWT `sub` claim, not a secret.
export function getCurrentUserId() {
  if (typeof document === 'undefined') {
    return null;
  }
  const match = document.cookie.match(/(?:^|;\s*)uid=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : null;
}

// Boot the session on app load. If we already have a valid cookie, /auth/me
// returns the user. Otherwise mint a fresh anonymous one. Returns the user DTO.
export async function bootstrapSession() {
  try {
    const res = await apiClient.get('/auth/me');
    return res.data.user;
  } catch (err) {
    if (err?.response?.status === 401) {
      const fresh = await apiClient.post('/auth/anonymous');
      return fresh.data.user;
    }
    throw err;
  }
}

export async function signOut() {
  try {
    await apiClient.post('/auth/logout');
  } finally {
    // The backend cleared cookies; immediately mint a new anon session so the
    // SPA never sits in an "no identity" state.
    try {
      await apiClient.post('/auth/anonymous');
    } catch {
      /* swallow — the next page load will retry */
    }
  }
}
